module.exports = __webpack_public_path__ + "img/head_rechts_12.2017.73b9451d.svg";